import React from 'react';
import { aboutParagraphs, glance, industries, specialties } from '../data/profile';
import { Reveal } from '../components/Reveal';
import { SectionHeading } from '../components/SectionHeading';
export function About() {
  return <section aria-labelledby="about-title" className="bg-paper py-20 md:py-28" data-id="element-112" data-mp="29l6pb77gdhfv">
      <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-113" data-mp="2ejrp55islz3s">
        <SectionHeading id="about-title" label="02 · About" title="Technology strategy, grounded in the business." data-id="element-114" data-mp="328ayzphhqjxz" />

        <div className="mt-16 grid gap-16 lg:grid-cols-12" data-id="element-115" data-mp="377xde292268d">
          <Reveal className="lg:col-span-7" data-id="element-116" data-mp="375b49y6inio1">
            <p className="font-serif text-2xl leading-snug text-ink md:text-3xl" data-id="element-117" data-mp="2sawijpvkhv5o">
              Regional technology executive, former CIO and board chairman, with deep roots in sales, channels and
              marketing across Latin America.
            </p>
            <div className="mt-8 space-y-5 text-base leading-relaxed text-slate-text md:text-lg" data-id="element-118" data-mp="1gxavca99q3ms">
              {aboutParagraphs.map(p => <p key={p} data-id="element-119" data-mp="1uh0axwv0t3np">{p}</p>)}
            </div>
            <div className="mt-12 border-t border-line pt-8" data-id="element-120" data-mp="1pip0bjwwip4f">
              <h3 className="text-sm font-semibold text-ink" data-id="element-121" data-mp="1pk9wtf2s0i4x">Specialties</h3>
              <ul className="mt-5 flex flex-wrap gap-2.5" data-id="element-122" data-mp="23jj6rx0e2g0g">
                {specialties.map(s => <li key={s} className="rounded-sm border border-line px-3.5 py-2 text-sm text-ink" data-id="element-123" data-mp="1yiltnyu8kc5t">
                    {s}
                  </li>)}
              </ul>
            </div>
          </Reveal>

          <Reveal delay={0.05} className="lg:col-span-5" data-id="element-124" data-mp="28hb1szwbyi8v">
            <div className="border-l border-line pl-8" data-id="element-125" data-mp="2m97qetysia0i">
              <p className="font-serif text-7xl leading-none text-ink" data-id="element-126" data-mp="2maskkih6zqxu">{glance.primary.value}</p>
              <p className="mt-3 text-sm text-slate-text" data-id="element-127" data-mp="2i9qi7srzayrn">{glance.primary.label}</p>
              <dl className="mt-10 grid grid-cols-3 gap-6 border-t border-line pt-8" data-id="element-128" data-mp="2w7f2aye821vn">
                {glance.secondary.map(item => <div key={item.label} data-id="element-129" data-mp="1ouwjzuik2fxm">
                    <dt className="sr-only" data-id="element-130" data-mp="1ovxxs6qyhgj1">{item.label}</dt>
                    <dd data-id="element-131" data-mp="1svq6qkk9hoox">
                      <span className="block font-serif text-3xl text-ink" data-id="element-132" data-mp="1sx9mma209xq6">{item.value}</span>
                      <span className="mt-2 block text-xs leading-snug text-slate-text" data-id="element-133" data-mp="1xu9tgn6oj4ic">{item.label}</span>
                    </dd>
                  </div>)}
              </dl>
              <div className="mt-10 border-t border-line pt-8" data-id="element-134" data-mp="27lxfu9odpvcy">
                <h3 className="text-sm font-semibold text-ink" data-id="element-135" data-mp="27ngz895c0miy">Industry experience</h3>
                <ul className="mt-4 space-y-2.5" data-id="element-136" data-mp="2cmbo9stw77bi">
                  {industries.map(industry => <li key={industry} className="flex gap-3 text-sm text-slate-text" data-id="element-137" data-mp="2gjzn36yphk8o">
                      <span className="mt-2 h-px w-3 shrink-0 bg-bronze" aria-hidden="true" data-id="element-138" data-mp="2lit2j4xjzlbh" />
                      {industry}
                    </li>)}
                </ul>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>;
}